import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import categoriesModel from "venuescanner-js/react/components/VirtualEvents/models/categories";

import CategoryCta from "venuescanner-js/react/components/VirtualEvents/components/CategoryCta";
import isSSR from "venuescanner-js/services/isSSR";

const Categories = (props) => {
  const { setIsFormOpen } = props;
  // TODO add a category dynamic slug to the router and then initialise this categories with the router item chosen
  const [activeCategory, setActiveCategory] = useState(categoriesModel[0]);
  const [areCategoriesOpen, setAreCategoriesOpen] = useState(false);
  const [isMobileDevice] = useState(isSSR() ? false : window.innerWidth < 1200);
  const animate = useRef(null);

  useEffect(() => {
    if (isSSR()) return;
    animate.current.classList.remove("visible");
    setTimeout(() => animate.current.classList.add("visible"), 1);
  }, [activeCategory]);

  const categoryCtas = categoriesModel.map((category, index) => (
    <CategoryCta
      key={category.name + index}
      isActive={activeCategory.name === category.name}
      category={category}
      setAreCategoriesOpen={setAreCategoriesOpen}
      setActiveCategory={setActiveCategory}
    />
  ));
  return (
    <div className="virtual-events-categories animate" ref={animate}>
      <div className="container">
        <h2 className="virtual-events-categories__title">
          Popular virtual event activities
        </h2>
        <div className="virtual-events-categories__carousel">
          <div
            className={`virtual-events-categories__ctas ${
              areCategoriesOpen ? "isOpen" : "isClosed"
            }`}
          >
            {isMobileDevice && (
              <div
                className="virtual-events-categories__nav"
                onClick={() => setAreCategoriesOpen(!areCategoriesOpen)}
              >
                <span className="p">Select Category</span>
              </div>
            )}
            {categoryCtas}
          </div>

          <div className="virtual-events-categories__image">
            <div className="virtual-events-categories__image__live">
              <span className="live__indicator" />
              <span className="live__copy caption">Live</span>
            </div>
            <img
              className="virtual-events-categories__image__bg"
              src={activeCategory.img}
              alt="Active category"
            />
            <img
              className="virtual-events-categories__image__menu"
              src="https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/category_image_ipad_menu.png"
              alt="ipad buttons"
            />
          </div>

          <div className="virtual-events-categories__copy">
            <h3 className="virtual-events-categories__copy__title">
              {activeCategory.name}
            </h3>
            <p className="virtual-events-categories__copy__info">
              {activeCategory.copy}
            </p>
            <div className="virtual-events-categories__copy__ctas">
              <NavLink
                to={{ pathname: `/virtual-events/${activeCategory.slug}` }}
              >
                <button
                  className="button button--outline"
                  data-ga={`virtual_events_category_${activeCategory.slug}--view-activties`}
                >
                  View Activities
                </button>
              </NavLink>
              <button
                className="button button--light"
                onClick={() => setIsFormOpen(true)}
                data-ga={`virtual_events_category_${activeCategory.slug}--enquire-now`}
              >
                Enquire Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
